AFRAME.registerSystem("npc-audio", {
  init: function () {
    this.audioEl = document.createElement('audio');
  },
  
});